import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  CircularProgressLabel,
  Flex,
  HStack,
  Image,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { RiUploadCloud2Line } from "@remixicon/react";
import { ReactSVG } from "react-svg";
import like from "@/assets/like.svg";
import collect from "@/assets/collect.svg";
import comment from "@/assets/comment.svg";
import { MyModelDetail, MyModel } from "@/types/creatorcenter";
import ModelDetailsModal from "./modelDetailsModal";
import EditModelDetailModal from "./editModelDetailModal";
import modelImg from "@/assets/images/creator_model_img1.png";
import { useAppDispatch } from "@/store/hooks";
import { resetMyModel, updateCurrentModelCover, updateCurrentTrainId, updateModelcovers, updateModelPublishParams, updateTrainingPictures } from "@/reducer/mymodelSlice";
import NewTrainingModal from "./newTrainingModal";
import { useEffect, useState } from "react";
import { useLazyGetTrainsQuery } from "@/services/api/endpoints/model";
import { useSelector } from "react-redux";
import { selectUser } from "@/reducer/userslice";

type Props = {
  myModel: MyModelDetail;
  handleOpenResult: ()=>void;
};
const ModelTrainingItem = (props: Props) => {
  const user = useSelector(selectUser);
  const dispatch = useAppDispatch();
  const { myModel } = props;
  const detailControl = useDisclosure();
  const editControl = useDisclosure();
  const NewTrainingControl = useDisclosure();

  // const [trainsList, setTrainsList] = useState<MyModelDetail[]>([]);
  // const [curIndex, setCurIndex] = useState<number>(0);

  // const [getTrains] = useLazyGetTrainsQuery();

  // const updataTrainList = async () => {
  //   const dataList = await getTrains({ user_id: user.id });
  //   if (dataList.data) {
  //     setTrainsList(dataList.data);
  //     let index = dataList.data?.findIndex(element => element.id === myModel.id);
  //     setCurIndex(index)
  //   }
  // };
  // useEffect(() => {
  //   updataTrainList();
  // }, []);

  const handleClickModel = () => {
    detailControl.onOpen();
  };



  const handleEditModelDetail = () => {
    dispatch(updateModelcovers(myModel.preview))
    dispatch(updateCurrentModelCover(""))
    dispatch(updateModelPublishParams(myModel))
    dispatch(updateCurrentTrainId(myModel.id));
    editControl.onOpen();
  };

  const handleOpenTrain = () => {
    if(myModel.train_status === "未开始"){
      dispatch(resetMyModel());
    dispatch(updateTrainingPictures([]));

    dispatch(updateCurrentTrainId(myModel.id));
    // dispatch(updateModelPublishParams({...item}));
    NewTrainingControl.onOpen();
    }  
    if(myModel.train_status === "训练完成"){
      dispatch(updateModelcovers([]))
    dispatch(updateCurrentModelCover(""))
    dispatch(updateModelPublishParams(myModel))
    dispatch(updateCurrentTrainId(myModel.id));
    editControl.onOpen();
    }
  };

  return (
    <Box position={"relative"} h="160px">
      {
        myModel.status==="已发布" && 
        <Image 
        w={"100%"} 
        h="100%"
        objectFit={"cover"}
        src={myModel.model_cover} 
        onClick={handleClickModel}
      />
      }
      {
        myModel.status==="未发布" && 
        <Image 
        w={"100%"} 
        h="100%"
        objectFit={"cover"}
        src={modelImg } 
        cursor="pointer"
        onClick={handleOpenTrain} 
      />
      }
      
      <HStack position={"absolute"} top="10px" left={"10px"} spacing="0">
        {
          myModel.model_type && 
          (
            <Box p="0 8px" bg="#000000" h="22px" color={"#FFFFFF"} fontSize="12px">
          {myModel.model_type}
        </Box>
          )
        }
        
        {/* <HStack p="0 8px" bg="rgba(255, 255, 255, 0.5)" h="22px" color={"#27314D"} fontSize="12px">
          <RiUploadCloud2Line size="14px" />
          <Text>{myModel.update_time}</Text>
          </HStack> */}
      </HStack>
      {myModel.train_status === "训练完成" && (
        <Box
          p="0 8px"
          h="25px"
          lineHeight={"25px"}
          position={"absolute"}
          top="10px"
          right={"10px"}
          bg={"#50AC54"}
          color="#FFFFFF"
          fontSize={"12px"}
        >
          训练完成
        </Box>
      )}
      {myModel.train_status === "共享中" && (
        <Box
          p="0 8px"
          h="25px"
          lineHeight={"25px"}
          position={"absolute"}
          top="10px"
          right={"10px"}
          bg={"linear-gradient(90deg, #8E94A9 0%, #27314D 100%)"}
          color="#FFFFFF"
          fontSize={"12px"}
        >
          共享中
        </Box>
      )}
      {myModel.train_status === "未开始" && (
        <Box
          p="0 8px"
          h="25px"
          lineHeight={"25px"}
          position={"absolute"}
          top="10px"
          right={"10px"}
          bg={"linear-gradient(90deg, #8E94A9 0%, #27314D 100%)"}
          color="#FFFFFF"
          fontSize={"12px"}
        >
          未开始
        </Box>
      )}
      <Box
        p="5px 8px"
        bg="rgba(39, 49, 77, 0.3)"
        position={"absolute"}
        bottom="0px"
        left={"0px"}
        h="72px"
        w="100%"
      >
        <Box fontSize={"14px"} h="25px" lineHeight={"25px"} fontWeight="700" color={"#FFFFFF"}>
          {myModel.model_name}
        </Box>
        <Flex mt="5px" justifyContent={"space-between"} alignItems="center">
          <HStack>
            <Avatar src={`/api/v4/users/${myModel.user_id}/image`} w={"24px"} h={"24px"} />
            <Text ml="10px" color={"#FFFFFF"} fontSize="14px" fontWeight={350}>
              {myModel.username}
            </Text>
          </HStack>
          {myModel.train_status === "训练完成" && myModel.status!=="已发布" && (
            <Button
              borderRadius={"40px"}
              width={"72px"}
              height={"30px"}
              color="#FFFFFF"
              bgColor="#496AE1"
              fontWeight={"normal"}
              fontSize="12px"
              _hover={{
                bgColor: "#3F5BC1",
                color: "#E6E6E6",
              }}
              onClick={handleEditModelDetail}
            >
              去设置
            </Button>
          )}
        </Flex>
      </Box>
      {myModel.train_status === "训练中" && (
        <Flex
          justifyContent={"center"}
          alignItems="center"
          bg="rgba(0, 0, 0, 0.7)"
          position={"absolute"}
          top="0px"
          left={"0px"}
          w="100%"
          h="100%"
        >
          <Flex flexDir={"column"} alignItems="center">
            <Box>
              {/* <CircularProgress value={70} size="80px" thickness="8px">
                <CircularProgressLabel color={"#FFFFFF"}>
                  70%
                </CircularProgressLabel>
              </CircularProgress> */}
            </Box>
            <Box  color={"#FFFFFF"} fontSize="16px" fontWeight={350}>
              训练中，请稍等
            </Box>
          </Flex>
        </Flex>
      )}

      <ModelDetailsModal
        isOpen={detailControl.isOpen}
        onClose={detailControl.onClose}
        myModel={myModel}
        // trainsList={trainsList}
        // curIndex= {curIndex}
      />

      <EditModelDetailModal
        isOpen={editControl.isOpen}
        onClose={editControl.onClose}
      />

      <NewTrainingModal
        isOpen={NewTrainingControl.isOpen}
        onClose={NewTrainingControl.onClose} 
        handleOpenResult={props.handleOpenResult} />
    </Box>
  );
};

export default ModelTrainingItem;
